export default __webpack_public_path__ + "static/media/unverified.59950c9a.svg";